export var compareValues=function(first,second){return null!==first&&null!==second&&first.id===second.id};